import searchTracking from "./search"

export default  searchTracking
